import { ContextProvider } from "./context/context";
import Routes from "./router/routes";
import theme from "./styles/theme";
import { ThemeProvider } from "@material-ui/styles";
import { Footer } from "./shared/components";
function App() {
  return (
    <ContextProvider>
      <ThemeProvider theme={theme}>
        <div style={{ padding: "0 24px" }}>
          <Routes />
          <Footer />
        </div>
      </ThemeProvider>
    </ContextProvider>
  );
}

export default App;
